<template>
  <div>
    <h3>Memberships</h3>
    <apexchart
      width="450"
      height="450"
      ref="chart"
      :options="chartOptions"
      :series="series"></apexchart>
    <div class="d-flex justify-content-center">
      <b-button variant="primary" @click="$emit('show-modal')"
        >Details memberships</b-button
      >
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        values: {
          avg_cash: '0.00',
          avg_total: '0.00',
          cant: 0,
          cash: 0,
          total: 0,
        },
      }),
    },
  },
  computed: {
    series() {
      return [
        {
          name: 'Cash',
          data: [this.data.values.cash],
        },
        {
          name: 'Average Cash',
          data: [parseFloat(this.data.values.avg_cash)],
        },
        {
          name: 'Total',
          data: [this.data.values.total],
        },
      ]
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          categories: ['Values'],
        },
        title: {
          text: 'Memberships Data',
          align: 'center',
        },
      }
    },
  },
  mounted() {
    this.$refs.chart.updateOptions(this.chartOptions)
  },
}
</script>

<style scoped></style>
